const COUNTER_ID = 100285856;

// Overload declarations for the ym wrapper
function ymWrapper(eventName: 'init', parameters: ym.InitParameters): void;
function ymWrapper(eventName: 'addFileExtension', extensions: string | string[]): void;
function ymWrapper<CTX>(eventName: 'extLink', url: string, options?: ym.ExtLinkOptions<CTX>): void;
function ymWrapper<CTX>(eventName: 'file', url: string, options?: ym.FileOptions<CTX>): void;
function ymWrapper(eventName: 'getClientID', cb: (clientID: string) => void): void;
function ymWrapper<CTX>(eventName: 'hit', url: string, options?: ym.HitOptions<CTX>): void;
/** @deprecated */
function ymWrapper(
  eventName: 'hit',
  url: string,
  title?: string,
  referer?: string,
  params?: ym.VisitParameters,
): void;
function ymWrapper<CTX>(eventName: 'notBounce', options?: ym.NotBounceOptions<CTX>): void;
function ymWrapper(
  eventName: 'params',
  parameters: ym.VisitParameters | ym.VisitParameters[],
): void;
function ymWrapper<CTX>(
  eventName: 'reachGoal',
  target: string,
  params?: ym.VisitParameters,
  callback?: (this: CTX) => void,
  ctx?: CTX,
): void;
function ymWrapper(eventName: 'replacePhones'): void;
function ymWrapper(eventName: 'setUserID', userID: string): void;
function ymWrapper(eventName: 'userParams', parameters: ym.UserParameters): void;

function ymWrapper(...args: any[]): void {
  if (process.env.NODE_ENV !== 'production') return;
  return window.ym(COUNTER_ID, ...args);
}

export default ymWrapper;
